import { ITranslations } from 'types/common';
import { NavBarTransFields } from '.';
import en from 'translations/en/navBar.json';
import pl from 'translations/pl/navBar.json';
import sl from 'translations/sl/navBar.json';

export const navBarTranslations: ITranslations<NavBarTransFields> = {
  name: 'navBar',
  en,
  pl,
  sl,
};
